import React from "react";

export default function Footer() {
  return (
    <footer className="main-footer" style={{maxHeight: 100}}>
      <strong>
			  <a className="foot" href="https://cu24hs.cu.coop.py/scgi-bin/inicio.cgi">Universitaria Ltda. cu24 HS.</a>
      </strong>
      <div className="float-right d-none d-sm-inline-block">
       <p>Copyright © 2022 - Version 3.0  </p>     
      </div>
    </footer>
  );
}
